@charset "UTF-8";

/* app/js/src/components/clipping-studio/shared/destination-picker/clipping-studio-destination-picker.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: block;
  width: 100%;
}
.cs-destination-picker {
  width: 100%;
  display: block;
  height: 44px;
  box-sizing: border-box;
  border-radius: 6px;
  padding: 0 12px;
}
.cs-destination-picker ::ng-deep .selected-container {
  height: 100%;
  line-height: normal;
}
.cs-destination-picker ::ng-deep ul.dropdown-list {
  top: 100%;
}
.cs-destination-picker__option-row {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  max-width: 100%;
  vertical-align: middle;
}
.cs-destination-picker__option-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
}
.cs-destination-picker__option-icon-wrap {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.cs-destination-picker__option-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cs-destination-picker__option-icon ::ng-deep svg {
  width: 24px;
  height: 24px;
  display: block;
}
.cs-destination-picker__option-icon-wrap.platform--youtube {
  color: #ff0000;
}
.cs-destination-picker__option-icon-wrap.platform--facebook {
  color: #1877f2;
}
.cs-destination-picker__option-icon-wrap.platform--instagram {
  color: #e4405f;
}
.cs-destination-picker__option-icon-wrap.platform--twitch {
  color: #9146ff;
}
.cs-destination-picker__option-icon-wrap.platform--website {
  color: rgba(0, 0, 0, 0.54);
}
/*# sourceMappingURL=clipping-studio-destination-picker.component.css.map */
